/** The PDFs PDFMaker prints. */
export type PDFList =
  | 'Missing Receipt'
  | 'Missing Receipt Manager'
  | 'Retrievable Receipt'
  | 'Approved Proposal'
  | 'Pending Proposal';

export const receiptAffadavitTitle = 'KALOS MISSING RECEIPT AFFADAVIT';
export const retrievableAffadavitTitle = 'KALOS RETRIEVABLE RECEIPT AFFADAVIT';
export const receiptAffadavitLegal = `By signing this document I attest that I made this purchase and this
transaction is a legitimate business transaction for Kalos business
as stated and was unintentionally and irretrievably lost. I
understand that the business credit card is only for legitimate
expenses incurred to accomplish the business of Kalos Services Inc.`;

export const receiptAffadavitLegalManager = `By signing this document I attest that this
transaction is a legitimate business transaction for Kalos business
as stated and was unintentionally and irretrievably lost.`;

export const retrievableAffadavitLegal = `By signing this document I attest that I made this purchase and this
transaction is a legitimate business Transaction for Kalos business
as stated, can be retrieved from the vendor immediately upon
request, and is therefore compliant with IRS record keeping
requirements. I understand that the business credit card is only for
legitimate expenses incurred to accomplish the business of Kalos
Services Inc.`;

/** The receipt affidavit types the dashboard prints. */
export type ReceiptAffidavitType = Extract<
  PDFList,
  'Missing Receipt' | 'Missing Receipt Manager' | 'Retrievable Receipt'
>;

/** The text the person attests to, exactly as it prints on the PDF. */
export const receiptAffidavitLegalText = (pdfType: PDFList) =>
  pdfType === 'Missing Receipt Manager'
    ? receiptAffadavitLegalManager
    : pdfType === 'Missing Receipt'
      ? receiptAffadavitLegal
      : retrievableAffadavitLegal;
